export enum ClockStatus {
  Stopped = 'stopped',
  Running = 'running',
}
